module.exports = __webpack_public_path__ + "media/images/message_btm-84786d3205d051fb364d73d2ec55896c.png";